"use client";

import { useMediaQuery } from "@mantine/hooks";
import { BullasPage } from "@/components/partners/bullas/bullas-page";
import BullasMobilePage from "@/components/ui/bullas-mobile-page";

export default function Page() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isSmallScreen === true && <BullasMobilePage disabled={false} />}
      {isSmallScreen === false && <BullasPage />}
    </>
  );
}
